export default "/images/x_footer_logo.png";